
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function scopeDiscount1() {
                    var discount = this.calcDiscount(this.price, this.compare_at_price);
                    return _createElement('div', {
                        'className': 'card-badge top right',
                        'key': '232'
                    }, _createElement('span', { 'className': 'badge badge--sale badge--bottom-left badge--rounded' }, '\n          ', _translate(`product_sale_badge`, {  discount: discount  }), '\n        '));
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI3(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', { 'className': 'cm_product-item grid-item__link' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('a', {
                    'href': this.url,
                    'className': 'cm_product-item__image-container'
                }, _createElement('div', { 'className': 'cm_badge-container cm_badge-left' }, this.compare_at_price > this.price ? scopeDiscount1.apply(this, []) : null, this.out_of_stock ? _createElement('div', {
                    'className': 'card__badge',
                    'key': '569'
                }, _createElement('span', { 'className': 'badge badge--sold-out badge--bottom-left badge--rounded' }, _translate(`product_sold_out`))) : null, this.custom_badge ? _createElement('div', {
                    'className': 'card__badge',
                    'key': '759'
                }, _createElement('span', { 'className': 'badge badge--custom badge--rounded' }, this.custom_badge)) : null), _createElement('img', {
                    'className': 'cm_product-item__image' + (this.image2 ? ' cm_product-item__image_primary' : ''),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'cm_product-item__image cm_product-item__image_secondary',
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '1163'
                }) : null), _createElement('div', { 'className': 'cm_product-item__details' }, this.vendor && this.vendor_url ? _createElement('a', mergeProps({
                    'href': this.vendor_url,
                    'className': 'cm_product-item__vendor',
                    'key': '1441'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'cm_product-item__title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '18640'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI3.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], _createElement('div', { 'className': 'cm_product-item__sku-container' }, this.sku ? _createElement('div', {
                    'className': 'cm_product-item__sku',
                    'key': '2316'
                }, _createElement('span', { 'className': 'sku-title' }, 'SKU: '), _createElement('span', mergeProps({ 'className': 'sku-value' }, { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } }))) : null), this.stock_status ? _createElement('div', {
                    'className': 'cm_product-item__inventory product__inventory product__inventory--pill mb-05 t7',
                    'role': 'status',
                    'key': '2596'
                }, this.stock_status === 'low_stock' ? [
                    [_createElement('svg', {
                            'width': '20',
                            'height': '20',
                            'aria-hidden': 'true',
                            'className': 'product-inventory--low',
                            'key': '28090'
                        }, _createElement('circle', {
                            'className': 'bg-circle',
                            'cx': '10',
                            'cy': '10',
                            'r': '10',
                            'fill': 'rgba(253, 0, 0, 0.2)'
                        }), _createElement('circle', {
                            'cx': '10',
                            'cy': '10',
                            'r': '6',
                            'stroke': '#fff',
                            'strokeWidth': '1',
                            'fill': 'rgba(253, 0, 0, 0.6)'
                        }))],
                    '\n        ',
                    _translate(`product_inventory_low_stock`, {  count: this.inventory_quantity  }),
                    '\n      '
                ] : null) : null, _createElement('div', { 'className': 'cm_product-item__price-container' }, this.on_sale ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_compare',
                    'key': '3270'
                }, '\n        ', this.formatPrice(this.compare_at_price), '\n      ') : null, _createElement('div', { 'className': 'cm_product-item__price' }, this.price_varies ? _createElement('span', { 'key': '3473' }, _translate(`price_from`), ' ') : null, '\n        ', this.formatPrice(this.min_price || this.price), '\n      '), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_set',
                    'key': '3617'
                }, '\n        ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n      ') : null)), _createElement('div', { 'className': 'cm_product-item__buttons' }, this.out_of_stock ? _createElement('div', {
                    'onClick': e => window.Convermax.quickAdd(e, this),
                    'key': '3922'
                }, _createElement('button', {
                    'type': 'submit',
                    'name': 'add',
                    'className': 'quick-add__submit button button--full-width button--secondary button-with-icon button-with-icon--left',
                    'aria-haspopup': 'dialog',
                    'aria-live': 'polite',
                    'title': 'Add to cart',
                    'data-product-url': this.url
                }, _createElement('svg', {
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'className': 'icon icon-alert',
                    'aria-hidden': 'true',
                    'focusable': 'false',
                    'viewBox': '0 0 512 512'
                }, _createElement('path', {
                    'd': 'M427.68 351.43C402 320 383.87 304 383.87 217.35 383.87 138 343.35 109.73 310 96c-4.43-1.82-8.6-6-9.95-10.55C294.2 65.54 277.8 48 256 48s-38.21 17.55-44 37.47c-1.35 4.6-5.52 8.71-9.95 10.53-33.39 13.75-73.87 41.92-73.87 121.35C128.13 304 110 320 84.32 351.43 73.68 364.45 83 384 101.61 384h308.88c18.51 0 27.77-19.61 17.19-32.57zM320 384v16a64 64 0 01-128 0v-16',
                    'fill': 'none',
                    'stroke': 'currentColor',
                    'strokeLLinecap': 'round',
                    'strokeLinejoin': 'round',
                    'strokeWidth': '32'
                })), '\n        ', _translate(`product_out_of_stock`), '\n      ')) : null, !this.out_of_stock ? _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'cm_product-item__buttons-form',
                    'id': this.id,
                    'encType': 'multipart/form-data',
                    'key': '4958'
                }, this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'cm_button cm_button__secondary',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '51141'
                    }, '\n          ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n        ')] : null, this.variant_ids.length === 1 ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '54021'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '54023'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '54025'
                    }) : null,
                    _createElement('button', {
                        'className': 'cm_button cm_button__primary',
                        'type': 'submit',
                        'data-form-id': this.id,
                        'disabled': this.out_of_stock,
                        'key': '54027'
                    }, _createElement('svg', {
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'aria-hidden': 'true',
                        'focusable': 'false',
                        'className': 'icon icon-plus',
                        'fill': 'none',
                        'viewBox': '0 0 512 512',
                        'width': '19',
                        'height': '19'
                    }, _createElement('path', {
                        'fill': 'none',
                        'stroke': 'currentColor',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round',
                        'strokeWidth': '48',
                        'd': 'M256 112v288M400 256H112'
                    })), '\n          ', _translate(`product_add_to_cart`), '\n        ')
                ] : null) : null), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '6367'
                }) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []